export enum SearchResultType {
    Recipes = 'Recipes',
    Products = 'Products',
    Stores = 'Stores',
    Articles = 'Articles',
    Pointshop = 'Pointshop',
}
